export default __webpack_public_path__ + "static/media/beta_mob_banner.5e879a31.jpg";